export var OPENING_COLOR_TAG_REGEX = /^{\s*color\s*:\s*(#?\w+\s*)}/;
export var CLOSING_COLOR_TAG_REGEX = /^{\s*color\s*}/;
export var TOKEN_TYPE = 'color_text';
export var MARKUP = '{color}';
export var STYLE_TAG_TYPE = 'color';